import React from 'react';
/**
 * Spinner is a functional component in React that displays a loading spinner.
 *
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {number} props.pxSize - The size of the spinner in pixels. Defaults to 100 if not provided.
 *
 * @example
 * <Spinner pxSize={50} />
 *
 * @returns {JSX.Element} A div element containing the spinner.
 */
const Spinner = ({ pxSize = 100 }) => {
  /**
   * The component returns a div element with a spinner inside.
   * The spinner's width and height are determined by the pxSize prop.
   * The div is styled to be centered both vertically and horizontally.
   */
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <div
        className={`spinner-border w-${pxSize}px h-${pxSize}px`}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
